import React from 'react';
import { getDate, getMonth } from 'date-fns';
import { Typography } from '@mui/material';
import { style } from '@/styles/globals';
import { pr } from '@/utils/pxToRem';

const Banner = ({ name, company }: { name: string, company?: string }) => {
  const date = ` ngày ${getDate(new Date())} tháng ${getMonth(new Date()) + 1}`;
  return (
    <Typography
      sx={{
        ...style.text.heading1,
        padding: pr`16px`,
        paddingBottom: pr`24px`,
        textAlign: 'center',
        background: 'white',
        fontWeight: 500,
        // mt: '68px',
      }}
      color={style.color.black1}
      component="h1"
    >
      Vé máy bay
      {' '}
      {company || ''}
      {' '}
      {name}
      {' '}
      giá rẻ
      {date}
    </Typography>
  );
};

export default Banner;
